import { FC } from "react";
import { TableCell, TableHeadCell } from "@rothoblaas/design-system";
import AdminCrudTable from "../../../../components/ui/AdminCrudTable";
import useI18n from "../../../../hooks/useTranslations";
import { Support } from "../../../../http/deckDesigner/types/supports";
import useDeckSupportsApi from "../../../../http/deckDesigner/useSupports";
import SupportForm from "./SupportForm";

const AdminSupports: FC = () => {
  const i18n = useI18n();
  const supportsApi = useDeckSupportsApi();
  const unitMm = i18n.translation.common.unitMm;

  return (
    <AdminCrudTable<Support>
      filterPrefix="supports"
      useList={supportsApi.useDeckSupports}
      head={
        <>
          <TableHeadCell align="left">{i18n.translation.common.code}</TableHeadCell>
          <TableHeadCell align="left">{i18n.translation.common.description}</TableHeadCell>
          <TableHeadCell align="left">{i18n.translation.deckDesignerModule.supportFamilies.singular}</TableHeadCell>
          <TableHeadCell align="left">{i18n.translation.common.minHeight}</TableHeadCell>
          <TableHeadCell align="left">{i18n.translation.common.maxHeight}</TableHeadCell>
          <TableHeadCell align="left">{i18n.translation.common.stripeLength}</TableHeadCell>
          <TableHeadCell align="left">{i18n.translation.common.width}</TableHeadCell>
          <TableHeadCell align="left">
            {i18n.translation.deckDesignerModule.substructureMaterialClasses.plural}
          </TableHeadCell>
        </>
      }
      renderRow={(item) => (
        <>
          <TableCell>{item.item.code}</TableCell>
          <TableCell>{item.item.description}</TableCell>
          <TableCell>{item.supportFamily.name}</TableCell>
          <TableCell>
            {item.minHeight} {unitMm}
          </TableCell>
          <TableCell>
            {item.maxHeight} {unitMm}
          </TableCell>
          <TableCell>{item.stripeLength != null ? `${item.stripeLength} ${unitMm}` : "-"}</TableCell>
          <TableCell>
            {item.width} {unitMm}
          </TableCell>
          <TableCell>{item.materialClasses.map((materialClass) => materialClass.name).join(", ")}</TableCell>
        </>
      )}
      visibilityAndOrder={{
        updateVisibility: (item, visibility) => supportsApi.updateDeckSupportVisibility(item.item.id, { visibility }),
        updateOrder: (item, order) => supportsApi.updateDeckSupportOrder(item.item.id, { order }),
      }}
      onDelete={(item) => supportsApi.deleteDeckSupport(item.item.id)}
      deleteTitle={i18n.translation.deckDesignerModule.supports.singular}
      canAdd
      renderForm={(item, onClose) => <SupportForm support={item} onClose={onClose} />}
    />
  );
};

export default AdminSupports;
